



























import { Component, Vue, Prop } from "vue-property-decorator";
import { Collection, Document, Participant } from "@/types";

import * as firebase from "firebase/app"; // for types

@Component
export default class ChitChat extends Vue {
  @Prop({ required: true })
  chat!: Collection<string>;
  @Prop({ required: true })
  me!: Document<Participant>;

  newMessage = "";

  focus() {
    window.setTimeout(() => {
      (this.$refs.input as HTMLElement).focus();
    }, 0);
  }

  sendChatMessage() {
    if (this.newMessage.length > 0) {
      const newMsg = {
        sender: this.me.ref,
        msg: this.newMessage,
        added: firebase.firestore.FieldValue.serverTimestamp(),
      };
      this.chat.ref.add(newMsg);
    }
    this.newMessage = "";
  }
}
